import "./EditEquipmentDetails.html";
import "./EditEquipmentDetails.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditEquipmentDetailsComponentController from "./EditEquipmentDetailsComponentController";

export default class EditEquipmentDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditEquipmentDetailsComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/" +
            "SelectedEquipment/EditEquipmentDetails/EditEquipmentDetails.html";
    }
}

module("mmManagePortal").component("mmEditEquipmentDetails", new EditEquipmentDetailsComponent());
